export default __webpack_public_path__ + "static/media/oil500x667.e156166d.jpg";